module.exports = __webpack_public_path__ + "img/08_fruit list 1.95ec6e7e.png";